<template>
    <app-layout title="Chains">
        <page-header>
            <template #title>Chains</template>

            <template #actions>
                <jet-tertiary-button
                    type="button"
                    onclick="window.open('/chains/excel_export')"
                    title="Export Chains to Excel"
                    class="py-1 h-8"
                >
                    <img src="/images/icons/excel.svg" width="14" height="14" class="mx-auto" />
                </jet-tertiary-button>
                <jet-button :href="route('chains.create')">
                    Add
                </jet-button>
            </template>
        </page-header>

        <div class="px-8">
            <div class="flex">
                <form class="flex gap-2 flex-wrap lg:w-full" @submit.prevent="handleSubmit">
                    <div class="flex flex-1 gap-x-2">
                        <div class="flex flex-col flex-1">
                            <jet-label value="Search" />
                            <jet-input
                                type="text"
                                class="h-7"
                                v-model="form.search"
                                placeholder="Search..."
                                @input="handleSubmit"
                            />
                        </div>
                    </div>
                </form>

                <div class="self-end">
                    <jet-tertiary-button class="py-1 ml-4 h-7" @click="handleReset">
                        Reset
                    </jet-tertiary-button>
                </div>
            </div>
        </div>

        <div class="px-8 mt-4">
            <div class="rounded overflow-hidden border">
                <table class="table w-full">
                    <thead>
                        <tr>
                            <th class="text-left p-2">Code</th>
                            <th class="text-left p-2">Name</th>
                            <th class="text-left p-2"># of Customers</th>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="chain in chains.data" :key="chain.id" class="cursor-pointer hover:bg-gray-100" @click="goToEdit(chain.id)">
                                <td class="p-2">{{ chain.code }}</td>
                                <td class="p-2">{{ chain.name }}</td>
                                <td class="p-2">{{ chain.customers_count }}</td>
                            </tr>
                    </tbody>
                </table>
            </div>

            <div class="flex justify-between items-center mt-4">
                <pagination :links="chains.links" />

                <div class="w-40">
                    <multiselect
                        v-model.number="form.paginate"
                        :options="paginateOptions"
                        :canDeselect="false"
                        :canClear="false"
                        :classes="{ singleLabel: 'w-full px-2' }"
                        class="h-8 multi-sm multi-custom text-base"
                        openDirection="top"
                        @change="handleSubmit"
                    />
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { useForm, Link } from '@inertiajs/inertia-vue3'
import AppLayout from '@/Layouts/AppLayout.vue'
import PageHeader from '@/Layouts/partials/PageHeader.vue'
import JetButton from '@/Jetstream/Button'
import JetTertiaryButton from '@/Jetstream/TertiaryButton'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import Pagination from '@/Jetstream/Pagination'
import Multiselect from '@vueform/multiselect'

import '@vueform/multiselect/themes/default.css'

export default {
    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetTertiaryButton,
        JetInput,
        JetLabel,
        Link,
        Pagination,
        Multiselect,
    },

    props: {
        chains: Object,
        filters: Object,
        paginate: Number,
    },

    setup(props) {
        const form = useForm({
            search: props.filters.search || '',
            paginate: props.paginate || 20,
        });

        return { form }
    },

    data() {
        return {
            paginateOptions: [
                { value: 20, label: 'Show 20' },
                { value: 50, label: 'Show 50' },
                { value: 100, label: 'Show 100' },
            ],
        }
    },

    methods: {
        handleSubmit: _.debounce(function () {
            this.form.get(route('chains.index'), { preserveState: true });
        }, 250),

        handleReset() {
            this.form.search = ''
            this.form.paginate = 20
            this.handleSubmit()
        },

        goToEdit(id) {
            this.$inertia.get(route('chains.edit', id));
        },
    },
}
</script>
